var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscription-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L50 0L50 50L0 50L0 0Z",
    id: "Rectangle",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.6875 1.5625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40.625L34.375 40.625L34.375 0L0 0L0 40.625ZM31.25 37.5L3.125 37.5L3.125 3.125L31.25 3.125L31.25 37.5Z",
    transform: "translate(0 6.25)",
    id: "Shape",
    fill: "#1DA1F2",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 40.625L34.375 40.625L34.375 0L0 0L0 9.375L25 9.375L25 40.625ZM31.25 37.5L28.125 37.5L28.125 6.25L3.125 6.25L3.125 3.125L31.25 3.125L31.25 37.5Z",
    transform: "translate(6.25 0)",
    id: "Shape",
    fill: "#1DA1F2",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5625 18.75C0.698438 18.75 0 18.0516 0 17.1875L0 1.5625C0 0.698438 0.698438 0 1.5625 0C2.42656 0 3.125 0.698438 3.125 1.5625L3.125 17.1875C3.125 18.0516 2.42656 18.75 1.5625 18.75Z",
    transform: "translate(15.625 17.1875)",
    id: "Path",
    fill: "#1DA1F2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 3.125L1.5625 3.125C0.698438 3.125 0 2.42656 0 1.5625C0 0.698438 0.698438 0 1.5625 0L17.1875 0C18.0516 0 18.75 0.698438 18.75 1.5625C18.75 2.42656 18.0516 3.125 17.1875 3.125Z",
    transform: "translate(7.8125 25)",
    id: "Path",
    fill: "#1DA1F2",
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscription-icon.c22ba9aaa0833103fca6a708cbc7be38.svg";
export { ForwardRef as ReactComponent };